import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "confirmation-header" }
const _hoisted_2 = { class: "confirmation-icon-container" }
const _hoisted_3 = { class: "lead" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "text-primary mb-3" }, "What happens next?", -1)
const _hoisted_5 = { class: "confirmation-section" }
const _hoisted_6 = { class: "confirmation-section-heading mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "data-label" }, "Service Time:", -1)
const _hoisted_10 = {
  key: 0,
  class: "text-primary mb-3"
}
const _hoisted_11 = {
  key: 1,
  class: "text-primary mb-3"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "data-label" }, "Service Address:", -1)
const _hoisted_13 = { class: "h4 text-primary mb-3 service-address" }
const _hoisted_14 = {
  key: 3,
  class: "mb-2"
}
const _hoisted_15 = { class: "mb-0" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-primary mb-3" }, " The shop has received your information and is looking forward to servicing your vehicle. Vehicles are serviced in the order they arrive. ")
  ])
], -1)
const _hoisted_18 = { class: "row location-row" }
const _hoisted_19 = { class: "col-sm-12 location-with-hours" }
const _hoisted_20 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h5", null, "Hours", -1)
const _hoisted_24 = { class: "confirmation-section" }
const _hoisted_25 = { class: "confirmation-section-heading" }
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h4", { class: "text-primary mb-3" }, "Your Services", -1)
const _hoisted_28 = { class: "border" }
const _hoisted_29 = { class: "pt-3 px-3 d-flex justify-content-between" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("strong", null, "Total:", -1)
const _hoisted_31 = { class: "text-primary" }
const _hoisted_32 = {
  key: 0,
  class: "confirmation-section"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", { class: "confirmation-section-heading" }, "3. Point out your Lyft Amp or sticker", -1)
const _hoisted_34 = { class: "confirmation-section" }
const _hoisted_35 = { class: "confirmation-section-heading" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "payment-code--container" }
const _hoisted_38 = { class: "payment-code--bg" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Your Openbay Code: ", -1)
const _hoisted_40 = { class: "payment-code" }
const _hoisted_41 = { class: "confirmation-section" }
const _hoisted_42 = { class: "confirmation-section-heading" }
const _hoisted_43 = {
  key: 1,
  class: "border-top pt-4 d-flex justify-content-between flex-column flex-md-row"
}
const _hoisted_44 = { class: "flex-fill mb-2 mb-md-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_location_hours = _resolveComponent("location-hours")!
  const _component_offer_line_item_pricing_list = _resolveComponent("offer-line-item-pricing-list")!
  const _component_offer_subtotal_list = _resolveComponent("offer-subtotal-list")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["confirmation", { 'in-modal': _ctx.inModal }])
  }, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_inline_svg, {
          src: _ctx.asset(require(`@/assets/images/icons/circle-checkbox.svg`))
        }, null, 8, ["src"])
      ]),
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.subTitle), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.stepOne), 1),
      (!_ctx.offer.location.firstComeFirstServe)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (_ctx.offer.appointmentAt)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_10, _toDisplayString(_ctx.appointmentAt), 1))
                : (_openBlock(), _createElementBlock("h4", _hoisted_11, "Waiting for your appointment time to be confirmed.")),
              (_ctx.offer.location.doesHouseCalls)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_12,
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.offer.serviceAddress), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("h5", null, _toDisplayString(_ctx.offer.location.name), 1),
              (!_ctx.offer.location.doesHouseCalls)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.offer.location.address), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.offer.location.phoneNumber), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.offer.location.name), 1),
                (!_ctx.offer.location.doesHouseCalls)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.offer.location.address), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.offer.location.phoneNumber), 1),
                _hoisted_22,
                _hoisted_23,
                _createVNode(_component_location_hours, {
                  "location-hours": _ctx.offer.location.hours
                }, null, 8, ["location-hours"])
              ])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("h2", _hoisted_25, "2. Tell the " + _toDisplayString(_ctx.locationType) + " you booked with Openbay", 1),
      _createElementVNode("p", _hoisted_26, " The " + _toDisplayString(_ctx.locationType) + " has a record of your appointment and the service you requested. It’s always helpful to let the front desk know you booked your service through Openbay. If you have questions about the services you requested, ask the " + _toDisplayString(_ctx.locationType) + " before they start work on your vehicle. ", 1),
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_offer_line_item_pricing_list, {
          "offer-line-items": _ctx.offer.offerLineItems
        }, null, 8, ["offer-line-items"]),
        _createVNode(_component_offer_subtotal_list, { offer: _ctx.offer }, null, 8, ["offer"])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("span", _hoisted_31, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.totalAfterRewards), 1)
        ])
      ])
    ]),
    (_ctx.isLyftUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("p", null, " The " + _toDisplayString(_ctx.locationType) + " needs to see this to confirm that service is being performed on the vehicle you drive for Lyft. ", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("h2", _hoisted_35, _toDisplayString(_ctx.paymentCodeCopy.title), 1),
      _createElementVNode("p", {
        class: "mb-0",
        innerHTML: _ctx.paymentCodeCopy.description
      }, null, 8, _hoisted_36),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("h4", null, [
            _hoisted_39,
            _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.offer.settlementAuthorizationCode), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("h2", _hoisted_42, _toDisplayString(_ctx.invoiceStepHeading), 1),
      _createElementVNode("p", null, [
        _createTextVNode(" Once your service is complete, you can access your vehicle's service history in your "),
        _createVNode(_component_router_link, { to: "/profile" }, {
          default: _withCtx(() => [
            _createTextVNode("Profile")
          ]),
          _: 1
        }),
        _createTextVNode(". ")
      ])
    ]),
    (_ctx.displayFooter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("a", {
              href: "#",
              class: "btn btn-primary btn-block",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.done && _ctx.done(...args)), ["prevent"]))
            }, "Done!")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}